import { TriangleAlert } from "lucide-react";
import CommonCardUI from "../ui/Card/CommonCardUI";
import { useTranslation } from "react-i18next";
import { Typography } from "../ui";

export default function BoundaryFallback() {
  const { t } = useTranslation(["common", "errors"]);
  return (
    <section
      role="alert"
      className="flex h-screen w-screen items-center justify-center"
    >
      <CommonCardUI className="p-6 text-center">
        <Typography
          variant={"h3"}
          affects={"bold"}
          className="flex flex-row items-center text-destructive"
        >
          <TriangleAlert className="me-2 h-8 w-8 text-destructive" />
          {t("ERRORS.HTTP.UNKNOWN")}
        </Typography>
        <Typography variant={"p"} className="mt-2">
          {t("errors:HTTP.PlEASE_TRY_REFRESHING_PAGE")}
        </Typography>
      </CommonCardUI>
    </section>
  );
}
